import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import { networkLogos } from 'src/constants/networkLogos'
import { addOnCodes } from 'src/constants'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      addonCode={addOnCodes.nfl_redzone}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/Redzone2021_15s.mp4'}
      staticAnnotation={networkLogos.nflredzone}
      title="Watch NFL RedZone from NFL Network"
      subtitle="See every touchdown from Sunday afternoon"
      ctaText="Start Watching"
      networkSet="nfl"
      // Remove cable references
      removeCable={true}
      matchtickerSportId="111"
      matchtickerLeagueName="NFL"
      matchtickerLeagueId="191277"
      showRedzone={false}
    />
  )
}
